import request from './request'
import * as http from '@/libs/http'

/**
 * 指定条件の予約可能時間の一覧を返す
 *
 * @param {Number} shopid 店舗ID
 * @param {String} begin 検索開始日
 * @param {String} end 検索終了日
 * @param {Number} carid 車両ID
 * @param {Number} rid 検索から除外する予約番号
 * @returns {Response} レスポンスデータ
 */
export function getAvailableDays (shopid, begin, end, carid = 0, rid = 0) {
  return request.get(`/shops/${shopid}/available/days`, {
    params: {
      s: begin,
      e: end,
      carid: carid,
      rid: rid
    },
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
